import React from 'react';
import { Filter, X, ChevronDown } from 'lucide-react';

/**
 * FilterButton - Botón de filtros consistente
 * 
 * @param {boolean} active - Si hay filtros activos
 * @param {number} count - Número de filtros activos
 * @param {function} onClick - Función al hacer clic
 * @param {function} onClear - Función para limpiar filtros
 */
export const FilterButton = ({
  active = false,
  count = 0,
  onClick,
  onClear,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={onClick}
        className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl border text-sm font-medium transition-all ${
          active 
            ? 'bg-slate-900 text-white border-slate-900' 
            : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50 hover:border-slate-300'
        }`}
        data-testid="filter-button"
      >
        <Filter className="w-4 h-4" />
        <span>Filtros</span>
        {count > 0 && (
          <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-semibold ${
            active ? 'bg-white text-slate-900' : 'bg-slate-900 text-white'
          }`}>
            {count}
          </span>
        )}
        <ChevronDown className={`w-4 h-4 transition-transform ${active ? 'rotate-180' : ''}`} />
      </button>
      
      {count > 0 && onClear && (
        <button
          onClick={onClear}
          className="p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
          title="Limpiar filtros"
          data-testid="filter-clear"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default FilterButton;
